import { z } from 'zod';
/**
 * Prospect (ProspectQueue aggregate on the backend) — the unit of work
 * the dialer operates on. Lifecycle:
 *   pending → calling → contacted | skipped
 *           → do_not_call (terminal, opt-out)
 *
 * Backend invariants (from ProspectQueue aggregate):
 *   - phone and name are required and non-empty
 *   - markCalling() throws if doNotCall=true
 *   - transitions from terminal states (do_not_call, contacted) throw
 *
 * 'placeholder' and 'completed' are LEGACY values kept for historical reads.
 */
export const ProspectStatusSchema = z.enum([
    'pending',
    'calling',
    'contacted',
    'do_not_call',
    'placeholder',
    'completed',
    'skipped',
]);
export const AdditionalPhoneSchema = z.object({
    number: z.string(),
    label: z.string(),
});
export const ProspectSchema = z.object({
    id: z.string(),
    clientEmail: z.string().email(),
    prospectName: z.string().min(1),
    prospectPhone: z.string().min(1),
    prospectEmail: z.string().default(''),
    prospectCompany: z.string().default(''),
    prospectTitle: z.string().default(''),
    status: ProspectStatusSchema.default('pending'),
    priority: z.number().default(0),
    source: z.string().default(''),
    notes: z.string().default(''),
    customFields: z.record(z.string()).default({}),
    additionalPhones: z.array(AdditionalPhoneSchema).default([]),
    doNotCall: z.boolean().default(false),
    doNotCallAt: z.string().default(''),
    lastCallStatus: z.string().default(''),
    lastCallAt: z.string().default(''),
    createdDate: z.coerce.date(),
    updatedDate: z.coerce.date(),
});
/** Shape accepted by POST /api/prospects (once the god-endpoint is gone). */
export const CreateProspectInputSchema = ProspectSchema.pick({
    clientEmail: true,
    prospectName: true,
    prospectPhone: true,
    prospectEmail: true,
    prospectCompany: true,
    prospectTitle: true,
    source: true,
    priority: true,
    notes: true,
    customFields: true,
    additionalPhones: true,
}).partial({
    prospectEmail: true,
    prospectCompany: true,
    prospectTitle: true,
    source: true,
    priority: true,
    notes: true,
    customFields: true,
    additionalPhones: true,
});
//# sourceMappingURL=prospect.schema.js.map